/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ZerogTopGasSpenderRequest = {
    period?: ZerogTopGasSpenderRequest.period;
    type?: ZerogTopGasSpenderRequest.type;
    sort?: ZerogTopGasSpenderRequest.sort;
    direction?: ZerogTopGasSpenderRequest.direction;
};

export namespace ZerogTopGasSpenderRequest {

    export enum period {
        H24 = 'H24',
        D7 = 'D7',
    }

    export enum type {
        EOA = 'EOA',
        CA = 'CA',
        ALL = 'ALL',
    }

    export enum sort {
        TOTAL_GAS_USED = 'TOTAL_GAS_USED',
        TRX_COUNT = 'TRX_COUNT',
    }

    export enum direction {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

